import React, { useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { useLocation, useNavigate } from 'react-router-dom'
import { REACT_APP_UNIQUE_PASS_SEED } from '../../config/settings/environment'
import routes from '../../config/settings/routes'
import { useCsrfToken } from '../../modules/hooks/security'
import { onGetUniquePassTokenThunk } from './UniquePassAuth.actions'
import { onRegisterBy } from '../RegisterWizard/RegisterWizard.actions'
import { Root } from './UniquePassAuth.styles'
import { getCookie } from '@chilecompra/react-kit/storages'

/**
 * The UniquePassAuth's container.
 */
const UniquePassAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { loading } = useSelector(state => state.uniquePassAuth)
  const csrfToken = useCsrfToken(REACT_APP_UNIQUE_PASS_SEED)
  const hash = new URLSearchParams(location.hash)
  const code = hash.get('code')

  useEffectOnce(() => {
    batch(() => {
      dispatch(onGetUniquePassTokenThunk({ csrfToken, code }))
      dispatch(onRegisterBy('by-unique-pass'))
    })
  })

  useEffect(() => {
    if (loading) {
      return
    }
    const signWithCU = getCookie('signWithCU')

    if (signWithCU) {
      return navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'volunteers-agreement' } })
    }

    navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'personal-info' } })
  }, [loading])

  if (loading) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return null
}

export default UniquePassAuth
